const TAB_NAMES = ['Conta', 'Plano', 'Pagamento'];

function enabled(route) {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (route && route.query && (route.query.checkout_debug === '1' || route.query.checkout_debug === 'true')) {
    return true;
  }
  if (typeof window !== 'undefined' && window.location.search.indexOf('checkout_debug=1') > -1) {
    return true;
  }
  return false;
}

function ensureStore() {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!window.__checkoutDebug) {
    window.__checkoutDebug = {
      lastStep: null,
      lastAt: null,
      history: []
    };
  }
  return window.__checkoutDebug;
}

export function isCheckoutDebugEnabled(route) {
  return enabled(route);
}

export function checkoutSnapshot(vm) {
  if (!vm) {
    return {};
  }
  return {
    wizardTabIndex: vm.wizardTabIndex,
    wizardTab: TAB_NAMES[vm.wizardTabIndex] || vm.wizardTabIndex,
    checkoutStep: vm.checkoutStep,
    isPaymentTabActive: vm.isPaymentTabActive,
    paymentMethod: vm.paymentMethod,
    showGatewayForm: vm.showGatewayForm,
    hasGatewayLoader: !!vm.activeGatewayLoader,
    checkoutIsSubscription: vm.checkoutIsSubscription,
    basketProcessing: !!(vm.basket && vm.basket.processing),
    plansInBasket: vm.basket && vm.basket.plans ? vm.basket.plans.length : 0,
    planId: vm.planId,
    basketTotal: vm.basket && vm.basket.total,
    email: vm.basket && vm.basket.email
  };
}

export function checkoutLog(step, detail, route) {
  if (!enabled(route)) {
    return;
  }

  const store = ensureStore();
  const entry = {
    step,
    at: new Date().toISOString(),
    ...(detail || {})
  };

  if (store) {
    store.lastStep = step;
    store.lastAt = entry.at;
    store.history = store.history.slice(-99).concat(entry);
    store.snapshot = detail || {};
  }

  console.info(`[checkout] ${step}`, detail || '');
}

export function checkoutTabName(index) {
  return TAB_NAMES[index] || String(index);
}
